<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <div class="d-flex m__b--20">
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'silabus'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('silabus')">
        SILABUS
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'rpp'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('rpp')">
        RPP
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'ktsp'}"
        class="tab-experience-manager m__r--15 p__l--10 p__r--10"
        @click="selectTab('ktsp')">
        KTSP
      </div>
      <div
        :class="{'tab-experience-manager-active' : tabSelected === 'jadwal'}"
        class="tab-experience-manager p__l--10 p__r--10"
        @click="selectTab('jadwal')">
        JADWAL PELAJARAN
      </div>
    </div>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <!-- <b-button
            id="searchData"
            class="btn grey btn-import-form"
            @click="popoverSearchShow = true">
            <i class="fa fa-search fa-lg"/> Search
          </b-button> -->
        </b-form>
      </div>

      <div
        slot="id"
        slot-scope="props"
        @click="clickDetail(props.row)">
        {{ props.row.id }}
      </div>

      <div
        slot="title"
        slot-scope="props"
        @click="clickDetail(props.row)">
        {{ props.row.title }}
      </div>

      <div
        slot="status"
        slot-scope="props"
        @click="clickDetail(props.row)">
        {{ props.row.status.toUpperCase() }}
      </div>

      <div
        slot="category_name"
        slot-scope="props"
        @click="clickDetail(props.row)">
        {{ props.row.category_name }}
      </div>

      <div
        slot="created_date"
        slot-scope="props"
        @click="clickDetail(props.row)">
        {{ props.row.created_date }}
      </div>

      <div
        slot="updated_date"
        slot-scope="props"
        @click="clickDetail(props.row)">
        {{ props.row.updated_date }}
      </div>

      <div
        slot="action"
        slot-scope="props">
        <b-button
          v-if="props.row.attachment"
          class="btn green btn-import-form"
          @click="downloadSurat(props.row.attachment)">
          <i class="fa fa-lg fa-download"/>
        </b-button>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-popover
      ref="searchModal"
      :show.sync="popoverSearchShow"
      container="form-search-popover"
      target="searchData"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Dokumen Saya',
      },
      tabSelected: 'silabus',
      popoverSearchShow: false,
      filter_data: '',
      select_type: 'title',
      options_search: [
        {
          text: 'TITLE',
          value: 'title',
        },
        {
          text: 'CATEGORY',
          value: 'category_name',
        },
      ],
      load_first: false,
      length_table: '',
      data_table: [],
      selected_rows: [],
      columns: ['id', 'title', 'status', 'category_name', 'created_date', 'updated_date', 'action'],
      options: {
        headings: {
          id: 'ID',
          title: 'TITLE',
          status: 'STATUS',
          category_name: 'CATEGORY',
          created_date: 'CREATED DATE',
          updated_date: 'UPDATED DATE',
          action: 'DOWNLOAD',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['id', 'title', 'category_name', 'created_date', 'updated_date'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            limit: data.limit,
            page: data.page,
            module_id: data.module,
            category_id: data.category_id,
          };
        },
        requestFunction(data) {
          if (data.category_id === 1 || data.category_id === 2) {
            // eslint-disable-next-line
            data.status = 'approved';
          }
          const action = data.category_id === 1 || data.category_id === 2 ? 'getListAdminPembelajaran' : 'getListDokumenSaya';
          const getList = jApiKurikulum[action](data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.tableServer.setFilter('');
      }
    },
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),

    selectTab(status) {
      this.tabSelected = status;
      this.refreshTable();
    },

    loading(val) {
      const a = val;
      a.module_id = 1;

      switch (this.tabSelected) {
        case 'rpp':
          a.category_id = 1;
          break;
        case 'silabus':
          a.category_id = 2;
          break;
        case 'jadwal':
          a.category_id = 3;
          break;
        case 'ktsp':
          a.category_id = 15;
          break;
        default :
          a.category_id = 0;
      }

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    filter(val) {
      this.$refs.tableServer.setFilter(val);
    },

    clickDetail(data) {
      this.$router.push(`/admin-pembelajaran/requester/detail/me/${data.id}`);
    },

    downloadSurat(url) {
      window.open(url);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/admin-pembelajaran/jDokumenSaya.vue